module.exports = __webpack_public_path__ + "static/media/party_popper.68df0e66.gif";